import { combineReducers } from 'redux';
import selected from './slices/selected';

const webReducer = combineReducers({
  selected,
});

export default webReducer;
